module.exports = __webpack_public_path__ + "FixelDisplay-BoldItalic-fee6ed55fb2d0e59fdfa704933077adb.woff2";